import "core-js/modules/es.array.push.js";
import BatterTableDataView from "@/components/BatterTableDataView";
import api from "@/api";
import DialogCustomView from "@/components/DialogCustomView";
export default {
  name: "PoliceEventListView",
  components: {
    BatterTableDataView,
    DialogCustomView
  },
  data() {
    return {
      createVisible: false,
      eventViewVisible: false,
      eventUrl: null
    };
  },
  methods: {
    viewEvent(eid) {
      api.getPoliceEventViewPage(eid).then(url => {
        this.eventUrl = url;
        this.eventViewVisible = true;
      });
    },
    onDetailClick(data) {
      this.$router.push('/shop/detail/' + data.id);
    }
  }
};